import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

const AdminNavigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navigationItems = [
    {
      label: 'Service Requests',
      path: '/service-request-management-dashboard',
      icon: 'Wrench',
      description: 'Manage service requests'
    },
    {
      label: 'Drivers',
      path: '/drivers-management-portal',
      icon: 'Users',
      description: 'Manage driver records'
    },
    {
      label: 'Units',
      path: '/units-management-system',
      icon: 'Truck',
      description: 'Manage fleet units'
    },
    {
      label: 'Yards',
      path: '/yards-management-interface',
      icon: 'MapPin',
      description: 'Manage yard locations'
    },
    {
      label: 'Fleet Contacts',
      path: '/fleet-contacts-management',
      icon: 'Contact',
      description: 'Manage fleet contacts & managers'
    },
    {
      label: 'Assignments',
      path: '/assignment-management-center',
      icon: 'Link',
      description: 'Manage driver-unit assignments'
    },
    {
      label: 'RPM Personnel',
      path: '/rpm-personnel',
      icon: 'UserCheck',
      description: 'RPM staff alert recipients'
    }
  ];

  const isActive = (path) => location?.pathname === path;

  const handleNavigation = (path) => {
    navigate(path);
    setMobileMenuOpen(false);
  };

  return (
    <>
      <nav className="sticky top-16 z-[90] bg-card border-b border-border shadow-elevation-1">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="hidden md:flex items-center space-x-1 h-14">
            {navigationItems?.map((item) => (
              <button
                key={item?.path}
                onClick={() => handleNavigation(item?.path)}
                className={`
                  flex items-center space-x-2 px-4 py-2 text-sm font-medium rounded-md transition-hover
                  ${isActive(item?.path)
                    ? 'text-primary bg-primary/10 border-b-2 border-primary' :'text-muted-foreground hover:text-foreground hover:bg-muted/50'
                  }
                `}
                title={item?.description}
              >
                <Icon name={item?.icon} size={18} strokeWidth={2} />
                <span>{item?.label}</span>
              </button>
            ))}
          </div>

          <div className="flex md:hidden items-center justify-between h-14">
            <span className="text-sm font-medium text-foreground">
              {navigationItems?.find(item => isActive(item?.path))?.label || 'Navigation'}
            </span>
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="flex items-center justify-center w-10 h-10 text-foreground hover:bg-muted/50 rounded-md transition-hover"
            >
              <Icon name={mobileMenuOpen ? 'X' : 'Menu'} size={24} strokeWidth={2} />
            </button>
          </div>
        </div>
      </nav>
      {mobileMenuOpen && (
        <>
          <div 
            className="fixed inset-0 bg-background/80 backdrop-blur-sm z-[200] md:hidden"
            onClick={() => setMobileMenuOpen(false)}
          ></div>
          <div className="fixed top-[7.5rem] left-0 right-0 bg-card border-b border-border shadow-elevation-3 z-[210] md:hidden animate-slide-in">
            <div className="container mx-auto px-4 py-4">
              <div className="space-y-2">
                {navigationItems?.map((item) => (
                  <button
                    key={item?.path}
                    onClick={() => handleNavigation(item?.path)}
                    className={`
                      flex items-center space-x-3 w-full px-4 py-3 text-sm font-medium rounded-md transition-hover
                      ${isActive(item?.path)
                        ? 'text-primary bg-primary/10 border-l-4 border-primary' :'text-muted-foreground hover:text-foreground hover:bg-muted/50'
                      }
                    `}
                  >
                    <Icon name={item?.icon} size={20} strokeWidth={2} />
                    <div className="flex flex-col items-start">
                      <span>{item?.label}</span>
                      <span className="text-xs text-muted-foreground">{item?.description}</span>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default AdminNavigation;